import ACTION_ITEMS from '../actionItems';

const initialState = {
  currentPage: '',
  activeTab: '',
  selfDone: false,
  technicalDone: false,
  psychometricDone: false
};

export const navbarReducer = function (state = initialState, action) {
  switch (action.type) {
    case ACTION_ITEMS.NAVBAR.SET_CURRENT_PAGE_TAB:
      state = Object.assign({}, state, {
        currentPage: action.payload.currentPage,
        activeTab: action.payload.activeTab
      });
      break;

    case ACTION_ITEMS.NAVBAR.SELF_DONE.SET:
      state = Object.assign({}, state, {
        selfDone: action.payload.isDone
      });
      break;

    case ACTION_ITEMS.NAVBAR.TECHNICAL_DONE.SET:
      state = Object.assign({}, state, {
        technicalDone: action.payload.isDone
      });
      break;

    case ACTION_ITEMS.NAVBAR.PSYCHOMETRIC_DONE.SET:
      state = Object.assign({}, state, {
        psychometricDone: action.payload.isDone
      });
      break;

    default:
      break;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/components/navbar/reducers/navbarReducer.js